import { Controller } from '@hotwired/stimulus';

// Starts a tour from a control outside it — the tour controller lives on the thing being toured, which is
// never the button asking for it. Whether there is anything to tour yet is the caller's problem: lite's
// launcher is swapped for a disabled twin until the extension lands (lite_sidebar.scss), because its table
// is hidden behind the install panel until then.

// Left on rather than cleared when the animation ends: its last frame restores the element, so the class
// costs nothing sitting there, and replaying is a remove/reflow/add instead of a listener per run.
const NUDGE_CLASS = 'tour-launcher-nudge';

export default class extends Controller {
  static values = { name: String };

  // Answers "where did that go?" for someone who walked out of the tour. Not on a finish: they read the
  // closing step, which tells them the tour is over and asks them for something else.
  nudge({ detail }) {
    if (detail?.name !== this.nameValue || detail.completed) return;

    this.element.classList.remove(NUDGE_CLASS);
    // Flushes the removal, without which re-adding in the same frame is a no-op and nothing replays.
    this.element.getBoundingClientRect();
    this.element.classList.add(NUDGE_CLASS);
  }

  launch(event) {
    event.preventDefault();
    document.dispatchEvent(new CustomEvent('tour:launch', { detail: { name: this.nameValue } }));
  }
}
